import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "bg-grey-lighten-2 text-primary" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" 注意！！ ", -1)
        ]))]),
        _: 1
      }),
      (!_ctx.isActive)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 0,
            ref: "delete-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-3" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { style: {"margin-bottom":"20px","font-size":"12px","line-height":"14px"} }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" アカウントを削除すると、このアカウントではログインできなくなり、以下の情報が全て失われます。"),
                      _createElementVNode("br"),
                      _createTextVNode(" ※ MEMORUも同様にログインできなくなります。 ")
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "del" }, [
                    _createElementVNode("p", { class: "del_p" }, [
                      _createTextVNode(" ・連絡帳の全ての記録 "),
                      _createElementVNode("br"),
                      _createTextVNode(" ・チャット履歴 "),
                      _createElementVNode("br"),
                      _createTextVNode(" ・成長記録の全データ "),
                      _createElementVNode("br"),
                      _createTextVNode(" ・受信した全請求書 "),
                      _createElementVNode("br"),
                      _createTextVNode(" ・"),
                      _createElementVNode("strong", null, "MEMORUの全データ")
                    ])
                  ], -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.close,
                    color: "error",
                    variant: "text"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.changeTrue,
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" 続行する ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      (_ctx.isActive)
        ? (_openBlock(), _createBlock(_component_v_form, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "py-3" }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"margin":"0 auto 10px auto","text-align":"center"} }, [
                    _createElementVNode("p", null, "削除理由を入力してください。")
                  ], -1)),
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.comment,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                    rules: [_ctx.rules.required],
                    label: "",
                    "auto-grow": "",
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.close,
                    color: "error",
                    variant: "text"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    disabled: !_ctx.comment,
                    onClick: _ctx.del,
                    loading: _ctx.btnLoading,
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" 削除 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick", "loading"]),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_click_outside, _ctx.changeFalse]
  ])
}